import { gsap } from "gsap";
import { ScrollTrigger } from 'gsap/ScrollTrigger'
gsap.registerPlugin(ScrollTrigger);

console.log('gsap')

const mvElement = document.querySelector('.js-hero-parallax')
gsap.to(mvElement, {
  y: 800,
  ease: 'power0',
  scrollTrigger: {
    scrub: 1,
    // markers: true
  },
})

const footerBg = document.querySelector('.js-footer-bg')
gsap.set(footerBg, {
  rotation: '0.0001deg',
  // top: '-21vh',
})
gsap.to(footerBg, {
  y: 400,
  rotation: '0.0001deg',
  ease: 'power0',
  scrollTrigger: {
    trigger: footerBg,
    scrub: true,
    start: 'top 100%',
    // markers: true
  },
})

// gsap.utils.toArray('.js-parallax').forEach(wrap => {
//   const y = wrap.getAttribute('data-y') || -100;
  
//   gsap.to(wrap, {
//     y: y,    
//     scrollTrigger: {
//       trigger: wrap,
//       start: 'top bottom',
//       end: 'bottom top',
//       scrub: 0.5,
//       //markers: true
//     }
//   })
// })

const scrollImages = document.querySelectorAll('.js-scroll-img')
scrollImages.forEach(scrollImage => {
  gsap.to(scrollImage, 1, {
    y: '-25%',
    ease: 'power0',
    scrollTrigger: {
      trigger: scrollImage,
      start: 'top bottom',
      end: 'bottom top',
      scrub: true,
      // markers: true
    }
  })
})


const fadeElements = document.querySelectorAll('[data-animation="fade"]')
fadeElements.forEach(el => {
  gsap.from(el, 1.2, {
    opacity: 0,
    y: 20,
    scrollTrigger: {
      trigger: el,  
      start: 'top 70%',
      // markers: true
    }
  })
})

const toggleClassElements = document.querySelectorAll('[data-animation="toggleClass"]')
toggleClassElements.forEach((el, index) => {
  gsap.to(el, {
    scrollTrigger: {
      trigger: el,
      start: 'top 70%',
      once: true,
      toggleClass: {
        targets: el,
        className: 'is-show'
      }
    }
  })
})

// document.querySelectorAll(".className").forEach((el, index) => {
// });


// const fadeElements = document.querySelectorAll('[data-animation="fade"]')
// fadeElements.forEach(el => {
//   gsap.from(el, 1.2, {
//     opacity: 0,
//     // y: 20,
//     scrollTrigger: {
//       trigger: el,  
//       start: 'top 70%',
//       // markers: true
//     }
//   })

// })

// const textElements = document.querySelectorAll('[data-animation="text"]')
// textElements.forEach(el => {
//   gsap.from(el, .7, {
//     opacity: 0,
//     letterSpacing: '1em',
//     ease: 'sine',
//     scrollTrigger: {
//       trigger: el,  
//       start: 'top 70%',
//       // markers: true
//     }
//   })

// })

